import type { ReactNode } from "react";
import { Menu } from "../Menu/Menu";

type ActionCellAlign = "left" | "center" | "right";

const alignClass: Record<ActionCellAlign, string> = {
  left: "justify-start",
  center: "justify-center",
  right: "justify-end",
};

interface ActionCellProps {
  /** Action buttons rendered inline. */
  actions?: ReactNode;
  /** Menu items — auto-wrapped in a Menu kebab. Pass Button children directly. */
  menu?: ReactNode;
  /** Horizontal alignment of actions. Defaults to "right". */
  align?: ActionCellAlign;
  /** Lands on the menu's kebab trigger, so a test can open a row's menu. */
  "data-testid"?: string | undefined;
}

export function ActionCell({
  actions,
  menu,
  align = "right",
  "data-testid": dataTestid,
}: ActionCellProps) {
  return (
    <div className={`flex items-center ${alignClass[align]} gap-1`}>
      {actions}
      {menu && (
        <Menu {...(dataTestid !== undefined && { "data-testid": dataTestid })}>
          {menu}
        </Menu>
      )}
    </div>
  );
}
